export enum SkeletonType {
  CTA = 'CTA',
  CARD = 'CARD',
  BILL = 'BILL',
  Box = 'BOX',
  RECTANGLE = 'RECTANGLE',
  SLOTS = 'SLOTS',
}
